// data.js
export const faqTopics = [
    "General",
    "Booking and Reservation",
    "Pricing and Payment",
    "Property and Room Details",
    "Partnering with Znorm Homes",
    "Account and Privacy",
    "Customer Support"
  ];
  
  export const faqData = {
    "General":[
        {
            question: "What is Znorm Homes?",
            answer:
              "Znorm Homes is an online platform designed to make booking your next stay easier. We provide a wide range of hotel and resort accommodations across various cities, offering options to suit different budgets and preferences. Whether you’re looking for a luxurious getaway or a budget-friendly option, Znorm Homes helps you find the perfect place to stay.",
          },
          {
            question: "How is Znorm Homes different from other booking platforms?",
            answer:
              "At Znorm Homes, we go beyond just booking your stay. We focus on providing a comfortable and personalized experience for each guest. From a smooth booking process to ensuring that you have all the necessary information for a pleasant stay, we strive to make your experience as easy and enjoyable as possible. Plus, our customer support is available 24/7 to assist you.",
          },
          {
            question: "Is Znorm Homes available in all cities?",
            answer:
              "Currently, Znorm Homes operates in a select number of cities. We are continuously expanding, and our goal is to offer more locations in the near future. Check our website to see if we cover your preferred destination.",
          },
          {
            question: "Do I need an account to book a room on Znorm Homes?",
            answer:
              "No, you can book a room on Znorm Homes without creating an account. Simply browse available properties, select your desired accommodation, and proceed with booking. However, creating an account will allow you to save your preferences and receive exclusive offers.",
          },
          {
            question: "How do I leave a review for a property I stayed at?",
            answer:
              "We value your feedback! After your stay, you can submit your review directly through email or via the Znorm Homes website. We encourage you to share your experience so we can continue improving our services and help future guests make informed decisions.",
          },
    ],
    "Booking and Reservation": [
      {
        question: "Do I need an account to book a room on Znorm Homes?",
        answer: "No, you can book a room on Znorm Homes without creating an account..."
      },
      {
        question: "How do I leave a review for a property I stayed at?",
        answer: "We value your feedback! After your stay, you can submit your review..."
      }
    ],
    "Pricing and Payment": [
      {
        question: "Are there hidden fees?",
        answer: "No, all pricing details are transparent on Znorm Homes..."
      }
    ],
    "Property and Room Details": [
      {
        question: "Can I view photos of the property?",
        answer: "Yes, each property listing includes photos and details..."
      }
    ],
    "Partnering with Znorm Homes": [
      {
        question: "How do I list my property on Znorm Homes?",
        answer: "Please contact our team for partnership opportunities..."
      }
    ],
    "Account and Privacy": [
      {
        question: "How is my personal data handled?",
        answer: "We follow strict privacy policies to protect your data..."
      }
    ],
    "Customer Support": [
      {
        question: "Does Znorm Homes offer 24/7 customer support?",
        answer: "Yes, our support team is available 24/7..."
      }
    ]
  };
  